import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

import { firebaseConfig } from '../../environments/environment';

class Firebase {
  public auth: app.auth.Auth;
  public storage: app.storage.Storage;
  private db: app.firestore.Firestore;
  public Timestamp: any;
  public arrayUnion: any;
  public TaskEvent: any;
  public TaskState: any;

  constructor() {
    app.initializeApp(firebaseConfig);
    this.auth = app.auth();
    this.db = app.firestore();
    this.storage = app.storage();
    this.Timestamp = app.firestore.Timestamp;
    this.arrayUnion = app.firestore.FieldValue.arrayUnion
    this.TaskEvent = app.storage.TaskEvent
    this.TaskState = app.storage.TaskState
  }

  // *** Auth API ***

  doSignInWithEmailAndPassword = (email: string, password: string) =>
    this.auth.signInWithEmailAndPassword(email, password);
  
  createUserWithEmailAndPassword = (email: string, password: string, name: string) =>
    this.auth.createUserWithEmailAndPassword(email, password)
    .then((userCred) => {
      if (!userCred || !userCred.user) {
        console.error('no user found')
        return null
      }
      const userId = userCred.user.uid
      const batch = this.db.batch()
      const userDoc = this.users().doc(userId)
      const groupDoc = this.groups().doc()
      batch.set(userDoc, {
        groupIds: [''],
        name
      })
      batch.set(groupDoc, {
        userId,
        name: 'Mon flux'
      })
      return batch.commit()
    })
    .then(() => { return this.doSignInWithEmailAndPassword(email, password) })
 
  doSignOut = () => this.auth.signOut();

  // ***  API ***
  meals = () => this.db.collection('meals');
  users = () => this.db.collection('users');
  groups = () => this.db.collection('groups');
  ratings = () => this.db.collection('ratings');
  comments = () => this.db.collection('comments');
  batch = () => this.db.batch();
}
export default Firebase;